import { HttpHeaders } from '@angular/common/http';

export const SkipAuthInterceptorHeader = 'X-Skip-Auth-Interceptor';

/**
 * Call this method in the http request to skip the interceptor which adds the auth headers
 */
export function skipAuthInterceptor(headers: HttpHeaders = new HttpHeaders()): HttpHeaders {
	return headers.set(SkipAuthInterceptorHeader, '');
}

export const SkipTenantId = 'X-Skip-Tenant';

/**
 * Call this method in the http request to skip the interceptor which adds the auth headers
 */
export function skipTenantInterceptor(headers: HttpHeaders = new HttpHeaders()): HttpHeaders {
	return headers.set(SkipTenantId, '');
}
